import React, { useState, useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import './ToggleSwitch.css';
import { ManagerlApi, serviceApi, baseApi } from '../../API/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { FaTrash } from 'react-icons/fa'; // Import the trash icon from react-icons

const RoadDetectionTab = () => {
  const { isRoadDetectionEnabled, setIsRoadDetectionEnabled, setRunRoadDetection } =
    useFileContext();
  const [folderPath, setFolderPath] = useState('');
  const [showCheckMark, setShowCheckMark] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState('');
  const [requests, setRequests] = useState([]);


  const extractFolderId = (url) => {
    const parts = url.split('/');
    return parts[parts.length - 1];
  };

  const getFormattedTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleRunRoadDetection = async () => {
    const folderId = extractFolderId(folderPath);
    if (!folderId) {
      console.error('Invalid folder URL');
      return;
    }

    const apiUrl = `${ManagerlApi}/Road-Detection/${folderId}`;
    console.log(apiUrl);

    // Set current folderId and trigger the check mark display
    setCurrentFolderId(folderId);
    setShowCheckMark(false);
    setTimeout(() => {
      setShowCheckMark(true);
      setTimeout(() => setShowCheckMark(false), 6000); // Keep check mark visible for 6 seconds (4s visible + 2s fade out)
    }, 100); // Small delay to ensure state change is detected

    // Add the request to the list with start time and default status
    const startTime = getFormattedTime();
    const requestId = uuidv4();
    setRequests((prevRequests) => [
      ...prevRequests,
      { id: requestId, folderId, status: 'Sent', startTime },
    ]);

    // Clear the folder path input
    setFolderPath('');

    try {
      const response = await axios.post(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Update the request status in the list with response message
      const statusMessage = response.data.message || 'Task Completed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${statusMessage} ✅` }
            : request
        )
      );
    } catch (error) {
      console.error('There was an error running road detection!', error);

      // Update the request status in the list with error message
      const errorMessage = error.response?.data?.message || 'Task Failed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${errorMessage} ❌` }
            : request
        )
      );
    }
  };

  const handleDeleteRequest = (id) => {
    setRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== id)
    );
  };

  const handleClearAll = () => {
    setRequests([]);
  };

  useEffect(() => {
    setRunRoadDetection(() => handleRunRoadDetection);
  }, [folderPath, setRunRoadDetection]);

  return (
    <div>
      <div>
        <label>Folder Path</label>
        <input
          type='text'
          placeholder='Folder Name'
          value={folderPath}
          onChange={(e) => setFolderPath(e.target.value)}
        />
      </div>
      <div>
        <button onClick={handleRunRoadDetection}>
          Run Road Detection
        </button>
      </div>
      {showCheckMark && (
        <div className='check-mark'>Request {currentFolderId} Sent ✅</div>
      )}
      <div className='request-list'>
        <table>
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Status</th>
              <th>Start Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id}>
                <td>{request.folderId}</td>
                <td>{request.status}</td>
                <td>{request.startTime}</td>
                <td>
                  <button onClick={() => handleDeleteRequest(request.id)}>
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='clear-all-button' onClick={handleClearAll}>
          Remove All
        </button>
      </div>
    </div>
  );
};

export default RoadDetectionTab;
